import { firestoreTimestampToDate, isDate } from "../utils/obejct-diff"
import { Context, ContextMembership } from "./context.data"
import { ConditionType, IDependencyMapping } from "./db-dependencies"
import { NetworkConstants } from "./network.constants"

export interface IHuntingTenant{
    userId: String
    userName:String
}

export interface IFeeDebtor{
    userId: String
    userName:String
}

export interface IHuntingDistrict {
    identifier: string
    contextId: string
    county: string
    country:string
    countryCode:string
    name: string
    administrativeName: string
    state: string
    stateCode:string
    huntingOffice: string
    huntingOfficeId: string
    veterinarianOffice: string
    veterinarianOfficeId: string
    oldIdentifier: string
    gameOriginData?: GameOriginData
    extra?: ExtraData
    hiTierActive:boolean
    updateTimestamp?: Date,
    huntingTenant?:IHuntingTenant,
    feeDebtor?: IFeeDebtor,
    templateId?:string
}

interface GameOriginData {
    jabFirstName: string
    jabName: string
    jabAddress: string
    jabPostCode: string
    jabCity: string
    jabTelephone: string
    jabEmail: string
    jabSignature?: string
    
    gsName: string
    gsAdresse: string
    gsTel: string
    gsEmail: string
    gsFax: string

    erlegungsOrt: string
}

interface ExtraData{
    hitBNR?:string,
    hitMBN?:string,
    hitPIN?:string,
    hitREVAGS?:string,
}
const extractCoords = (str: string): [number, number] => {
    const split = str.split('|')
    const long = +split[0]
    const lat = +split[1]
    if (Number.isNaN(long) || Number.isNaN(lat)) throw new Error(`${str} does not contain formattable numbers`)
    else return [lat, long]
}

export interface Outline {
    identifier?: string
    contextId?: string
    creationDate?: Date
    updateTimestamp?: Date
    huntingDistrictId?: string
    polygon: {coordinates: string[], interior?: [{coordinates: string[]}]}
}

export class HuntingDistrict {

    static featureToFirebaseOutline(feature: any): Outline|undefined {
        if (feature.geometry?.coordinates[0]) {
            const coordinates = feature.geometry.coordinates[0]
            let listCoords: string[] = []
            coordinates.forEach((element: Number[]) => {
                listCoords.push(`${String(element[1])}|${String(element[0])}`)
            });
            let interior = []
            if (feature.geometry?.coordinates.length > 1) {
                // interior polygons
                for (let i = 1; i <= feature.geometry?.coordinates.length -1; ++i) {
                    let coords: any = []
                    if (feature.geometry?.coordinates[i]?.length) {
                        feature.geometry?.coordinates[i].forEach((coord: any) => {
                            coords.push(`${String(coord[1])}|${String(coord[0])}`)
                        });
                    }
                    if (coords.length > 0) interior.push(
                        {coordinates: coords}
                    )
                }
            }
            const polygon = {}
            if (listCoords.length > 0) Object.assign(polygon, {coordinates: listCoords})
            if (interior.length > 0) Object.assign(polygon, {interior: interior})
            const outline = {
                identifier: feature.properties?.outlineId,
                polygon
            }
            return outline as Outline
        } else {
            return undefined
        }
    }

    public static className = "HuntingDistrict"
    public className = "HuntingDistrict"

    public context: Context|ContextMembership|undefined = undefined
    identifier: string|undefined = undefined
    contextId: string|undefined = undefined
    contextIds: string[]|undefined = undefined
    contextIdRights: {[contextId: string]: 'view'|'update'}|undefined = undefined
    county: string|undefined = undefined
    country: string|undefined = undefined
    countryCode: string|undefined = undefined
    name: string|undefined = undefined
    administrativeName: string|undefined = undefined
    state: string|undefined = undefined
    stateCode: string|undefined = undefined
    huntingOffice: string|undefined = undefined
    huntingOfficeId: string|undefined = undefined
    veterinarianOffice: string|undefined = undefined
    veterinarianOfficeId: string|undefined = undefined
    oldIdentifier: string|undefined = undefined
    gameOriginData: GameOriginData|undefined = undefined
    extra: ExtraData|undefined = undefined
    updateTimestamp: Date|undefined = undefined
    hiTierActive: boolean|undefined = undefined
    creationDate: Date|undefined = undefined
    huntingTenant:IHuntingTenant| undefined = undefined
    feeDebtor: IFeeDebtor| undefined = undefined
    templateId?: string| undefined = undefined
    createdByUserName?:string|undefined = undefined
    createdByUserId?:string|undefined = undefined
    nvTrichinellaActive?: boolean|undefined = undefined
    mandatorySampleTypes?:string[]|undefined = undefined
    veterinaryOffice?:string|undefined = undefined
    veterinaryOfficeId?:string|undefined = undefined

    public outlines: Outline[]|undefined = undefined
    
    constructor(
        additionalContext?: Context|ContextMembership
    ) {
        this.context = additionalContext
    }

    setFromAny(element: any) {
        const {
            identifier,
            contextId,
            contextIds,
            contextIdRights,
            county,
            country,
            countryCode,
            name,
            administrativeName,
            state,
            stateCode,
            huntingOffice,
            huntingOfficeId,
            veterinarianOffice,
            veterinarianOfficeId,
            gameOriginData,
            hiTierActive,
            updateTimestamp,
            creationDate,
            extra,
            huntingTenant,
            feeDebtor,
            templateId,
            createdByUserId,createdByUserName, nvTrichinellaActive, mandatorySampleTypes, veterinaryOffice, veterinaryOfficeId
        } = element 
        //...
        this.identifier = identifier ? identifier : this.identifier
        this.contextId = contextId ? contextId : this.contextId
        this.contextIds = contextIds ? contextIds : this.contextIds
        this.contextIdRights = contextIdRights ? contextIdRights : this.contextIdRights
        this.county = county ?county : this.county
        this.country = country ? country : this.country
        this.countryCode = countryCode ?countryCode : this.countryCode
        this.name = name ? name : this.name
        this.administrativeName = administrativeName ? administrativeName : this.administrativeName
        this.state = state ? state : this.state
        this.stateCode = stateCode ? stateCode : this.stateCode
        this.huntingOffice = huntingOffice ? huntingOffice : this.huntingOffice
        this.huntingOfficeId = huntingOfficeId ? huntingOfficeId : this.huntingOfficeId   
        this.veterinarianOffice = veterinarianOffice ? veterinarianOffice : this.veterinarianOffice
        this.veterinarianOfficeId = veterinarianOfficeId ? veterinarianOfficeId : this.veterinarianOfficeId
        this.gameOriginData = gameOriginData ? gameOriginData : this.gameOriginData
        this.extra = extra ? extra : this.extra
        this.hiTierActive = hiTierActive ? hiTierActive : this.hiTierActive
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
        this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
        this.huntingTenant=huntingTenant ? huntingTenant : this.huntingTenant
        this.feeDebtor = feeDebtor ? feeDebtor : this.feeDebtor
        this.templateId = templateId ? templateId : this.templateId
        this.createdByUserName = createdByUserName ? createdByUserName : this.createdByUserName
        this.createdByUserId = createdByUserId ? createdByUserId : this.createdByUserId
        this.nvTrichinellaActive = nvTrichinellaActive ? nvTrichinellaActive : this.nvTrichinellaActive
        this.mandatorySampleTypes = mandatorySampleTypes ? mandatorySampleTypes : this.mandatorySampleTypes
        this.veterinaryOffice = veterinaryOffice ? veterinaryOffice : this.veterinaryOffice
        this.veterinaryOfficeId = veterinaryOfficeId ? veterinaryOfficeId : this.veterinaryOfficeId
    }

    getListItemTitle() {
        return this.name
    }

    searchFilter(filter: string): boolean {
        const str = `${this.name}${this.administrativeName}${this.county}`.toLowerCase()
        return str.includes(filter)
    }

    getOutlineGeoJson(): any|undefined {
        if (!this.outlines) return undefined
        let listFeature: any = this.getOutlinesAsFeatureList()
        const geoJsonBase = {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features':listFeature
            }
        }
        return geoJsonBase
    }

    getOutlinesAsFeatureList(): any[] {
        let listFeature: any = []
        this.outlines?.forEach((outline: Outline, index: Number) => {
            // parse outline coordinates.. 
            let list: any = []
            outline.polygon.coordinates.forEach(coordinate => {
                try {
                    const coord = extractCoords(coordinate)
                    list.push(coord)
                } catch (error) {
                    console.warn(error)
                }
            });
            const listInterior: any = []
            if (outline.polygon.interior) {
                outline.polygon.interior?.forEach(element => {
                    const coord: any = []
                    element.coordinates?.forEach((coordinate) => {
                        try {
                            const extracted = extractCoords(coordinate)
                            coord.push(extracted)
                        } catch (error) {
                            console.warn(error)
                        }
                        
                    })
                    if (coord.length > 0) {
                        listInterior.push(
                            coord
                        )
                    }
                });
            }
            let geometry = null
            if (listInterior.length > 0) {
                geometry = {
                    type: 'Polygon',
                    coordinates: [
                        list,
                        ...listInterior
                    ]
                }
            } else {
                geometry = {
                    type: 'Polygon',
                    coordinates: [
                        list
                    ]
                }
            }
            let feature = {
                'id': `${outline.identifier}`,
                'type': 'Feature',
                'properties': {
                    'outlineId': outline.identifier
                },
                geometry
            }
            listFeature.push(feature)
        })
        return listFeature
    }

    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key 
     */
    replacerFn(key: string) {
        if (key == "context" || key == "outlines" || key == "className") return false
        else return true
    } 
}

export const DependencyHuntingDistrictToEventInvitation: IDependencyMapping = {
    collectionName: NetworkConstants.COLLECTION_EVENT_INV,
    mapping: new Map<string, string>([
        ["name", "huntingDistrictName"]
    ]),
    getQuery: (firestore: any, origin: any, now: Date|null): any => {
        return (now != null) ? firestore.collection(NetworkConstants.COLLECTION_EVENT_INV)
            .where('huntingDistrictId', '==', origin['identifier'])
            .where('eventDate', '>=', now)
            :
            firestore.collection(NetworkConstants.COLLECTION_EVENT_INV)
            .where('huntingDistrictId', '==', origin['identifier'])
    },
    getDoc: (firestore: any, identifier: string) => {
        return null
    }
}